import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['panel'];
  static values = { index: Number };

  indexValueChanged() {
    this.hideCurrent();
  }

  change(event) {
    event.preventDefault();
    // The index lives on the element carrying the action; event.target may be an icon or a
    // wrapper inside it.
    const source = event.currentTarget?.dataset.hideIndex !== undefined ? event.currentTarget : event.target;
    this.indexValue = source.dataset.hideIndex;
  }

  hideCurrent() {
    this.panelTargets.forEach((panel, index) => {
      const isHidden = index === this.indexValue;
      panel.hidden = isHidden;
      panel.setAttribute('aria-hidden', isHidden.toString());
      this.syncRequired(panel, isHidden);
    });
  }

  // A `required` control inside a hidden panel can't be focused for native validation
  // ("An invalid form control with name='' is not focusable"), which blocks form submission.
  // Keep `required` in sync with the panel's visibility, remembering which controls we changed.
  syncRequired(panel, isHidden) {
    panel.querySelectorAll('[required], [data-reveal-required]').forEach((control) => {
      // awc-autocomplete observes its `required` attribute and cascades it to the inner input,
      // so we toggle the host element only and skip the input it reflects to.
      if (control.matches('[data-target="awc-autocomplete.input"]')) return;

      if (isHidden && control.hasAttribute('required')) {
        control.setAttribute('data-reveal-required', '');
        control.removeAttribute('required');
      } else if (!isHidden && control.hasAttribute('data-reveal-required')) {
        control.setAttribute('required', '');
        control.removeAttribute('data-reveal-required');
      }
    });
  }
}
